import React from 'react';

import { EMTPY_LIST_ITEMS } from '@common/constants';
import InputLabelWrapper from '../InputLabelWrapper';
import Select from '../Select';

interface InputMultiSelectOption {
	value: string;
	label: string;
}

interface InputMultiSelectProps {
	id?: string;
	label: string;
	isSortable: boolean;
	sortDirection: 'ascending' | 'descending' | 'none';
	onLabelClick: (...args: any[]) => void;
	onChange: (value: any) => void;
	placeholder?: string;
	labelDirection?: 'row' | 'col';
	/** Array of options to list as options */
	options?: InputMultiSelectOption[];
	/** Array of string values that exist in our list of options */
	value?: string[];
}

const InputMultiSelect: React.FC<InputMultiSelectProps> = ({
	id,
	label,
	isSortable,
	sortDirection,
	onLabelClick,
	value = EMTPY_LIST_ITEMS,
	placeholder = '',
	options = EMTPY_LIST_ITEMS,
	labelDirection = 'row',
	onChange,
}) => {
	return (
		<InputLabelWrapper
			label={label}
			isSortable={isSortable}
			sortDirection={sortDirection}
			onLabelClick={onLabelClick}
			direction={labelDirection}
		>
			<Select
				id={id}
				placeholder={placeholder}
				options={options}
				value={value}
				isMulti={true}
				isClearable={false}
				isSearchable={false}
				closeMenuOnSelect={false}
				hideSelectedOptions={false}
				onChange={(selectedOptions, action) => {
					switch (action) {
						case 'select-option':
						case 'remove-value':
						case 'deselect-option':
						case 'clear':
							onChange(selectedOptions);
							break;
						default:
							break;
					}
				}}
			/>
		</InputLabelWrapper>
	);
};

export default InputMultiSelect;
